import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaStatisticCardComponent } from './media-statistic-card.component';
import { TranslocoModule } from '@jsverse/transloco';
import { ImageUrlPipe } from '@frontend/shared';

@NgModule({
  declarations: [MediaStatisticCardComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    ImageUrlPipe,
  ],
  exports: [MediaStatisticCardComponent],
})
export class MediaStatisticCardModule {}
